import request from '@/assets/utils/request'

// 查询机器参数列表
export function feedingList(params) {
    return request({
      url: 'machine/find/fields',
      method: 'get',
      params:params
    })
  }
//修改机器系统的数据
export function feedingUpdate(data){
    return request({
    url: '/machine/update/field',
    method: 'post',
    data:data
    })
}

//查询用户信息
export function userQuery(){
  return request({
  url: '/user/findAll',
  method: 'get',
  })
}

//新增用户
export function userAdd(data){
  return request({
  url: '/user/add',
  method: 'post',
  data:data
  })
}

//新增用户添加头像
export function userAddImg(data){
  return request({
  url: '/logoImage/addUrl',
  method: 'post',
  data:data
  })
}

//用户修改
export function userUpdate(data){
  return request({
  url: '/user/update',
  method: 'post',
  data:data
  })
}

//查询用户头像
export function getAvatar(userId) {
  return request({
    url: '/logoImage/get?uuid='+userId,
    method: 'get',
  })
}

//删除用户
export function userDelete(userId) {
  return request({
    url: '/user/delete?uuid='+userId,
    method: 'get',
  })
}

//获取头部title
export function titleQuery(){
  return request({
  url: '/machine/find/title',
  method: 'get',
  })
}

//获取机器动画开关
export function machineStatus(){
  return request({
  url: '/machine/find/allShow',
  method: 'get',
  })
}

//修改机器动画开关
export function machineStatusUpdate(data){
  return request({
  url: '/machine/update/show',
  method: 'post',
  data:data
  })
}